import React from 'react'
import MenuItem from '@mui/material/MenuItem'
import FormControl from '@mui/material/FormControl'
import Select from '@mui/material/Select'
import InputLabel from '@mui/material/InputLabel'
import { SelectChangeEvent } from '@mui/material/Select'
import { etats } from '../../utils/constants'
import { systemLabel } from '../../utils/systemLabel'
import { useTranslation } from 'react-i18next';
import '../../i18n';

interface SelectetatsProps {
  value: string
  onChange: (event: SelectChangeEvent<string>, child: React.ReactNode) => void
}

const Selectetat: React.FC<SelectetatsProps> = ({ value, onChange }) => {


  const { t } = useTranslation();
  return (
    <FormControl fullWidth>
      <InputLabel id="etat-label">{t('State')}</InputLabel>
      <Select
        labelId="etat-label"
        id="etats"
        value={value}
        label="etat"
        onChange={onChange}
      >
        {etats.map((etat, index) => (
          <MenuItem key={index} value={etat}>
          {systemLabel(t, 'state', etat)}
         
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default Selectetat
